<mat-sidenav-container>
  <mat-sidenav mode="over">
    <mat-action-list class="actions">
      <button mat-list-item (click)="feature()">
        <span class="icon-action">
          <cq-icon-symbol name="golf_course"></cq-icon-symbol>
          Feature Flag Status
        </span>
      </button>
      <button mat-list-item (click)="upgrade()">
        <span class="icon-action">
          <cq-icon-symbol name="rule"></cq-icon-symbol>
          Page Upgrade Status
        </span>
      </button>
      <button mat-list-item (click)="mockup()">
        <span class="icon-action">
          <cq-icon-symbol name="view_quilt"></cq-icon-symbol>
          Mockup
        </span>
      </button>
      <button mat-list-item (click)="settings()">
        <span class="icon-action">
          <cq-icon-symbol name="settings"></cq-icon-symbol>
          Settings
        </span>
      </button>
      <button mat-list-item (click)="validation()">
        <span class="icon-action">
          <cq-icon-symbol name="navigation"></cq-icon-symbol>
          Validation Navigation
        </span>
      </button>
    </mat-action-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
